import { useTranslation } from 'react-i18next';
import { useScheduleContext } from '@/pages/Schedule/contexts';
import { ModalHeader as ChakraModalHeader } from '@/ui';
import { isPollSchedule } from '@/utils/schedule';

export const ModalHeader = () => {
  const { t } = useTranslation('addContent');
  const { schedule } = useScheduleContext();
  const isPoll = Boolean(schedule && isPollSchedule(schedule));

  return (
    <ChakraModalHeader
      borderBottomColor="customgray.gray"
      borderBottomWidth="1px"
      fontSize={{ base: 18, md: 20 }}
      fontWeight="medium"
      lineHeight="1"
      pb="6"
      pt="7"
      px={{ base: 6, md: 8 }}
    >
      {isPoll ? t('poll_title') : t('title')}
    </ChakraModalHeader>
  );
};
